import './../../styles/templates/wishlist.scss';

(function (window, $) {
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }

  const wishlistRender = function (products) {
    $(function () {
      var template = $('[data-wishlist-template]');
      var empty_template = $('[data-wishlist-empty]');
      var $wishlistContainer = $('#wishlist-content');

      var startLoading = function ($context) {
        if ($context) {
          $context.addClass('loading');
        } else {
          $wishlistContainer.addClass('loading');
        }
      }

      var stopLoading = function ($context) {
        if ($context) {
          $context.removeClass('loading');
        } else {
          $wishlistContainer.removeClass('loading');
        }
      }

      if (!products || products.length < 1) {
        empty_template.show();
        return;
      }

      products.forEach(function (p) {
        var row = template.clone();
        var productUrl = p.du;

        fetch(
          `/products/${
            productUrl.split("/")[productUrl.split("/").length - 1]
          }.json`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
            },
          }
        )
          .then((res) => res.json())
          .then((res) => {
        row.removeClass('hidden');
        row.find('[data-name]').html(p.dt);
        row.find('[data-vendor]').html(p.bt);
        row.find('[data-url]').attr('href', p.du);
        row.find('[data-image]').attr('src', p.iu);
        row.find('[data-price]').html(p.pr + _swat.currency);

        if (p.op && p.op > p.pr) {
          var percentage = Math.round((p.pr * 100 / p.op), 2);
          row.find('[data-percentage-value]').html(percentage);
          row.find('[data-percentage-wrapper]').removeClass('hidden');
          row.find('[data-price-container]').addClass('strike-price');
          row.find('[data-original-price]').html(p.op + _swat.currency);
        }

        row.find('[data-remove]').on('click', function (e) {
          e.preventDefault();
          startLoading(row);

          _swat.removeFromWishList(p, function callback() {
            row.remove();
            window.loadWishlistBubble(0);
            stopLoading(row);
          });
        });

        if (
          res?.product?.variants?.length &&
          res.product.variants.length > 1
        ) {
          row
            .find("[data-size")
            .append(
              res.product.variants.map(
                (variant) =>
                  "<option value=" +
                  variant.id +
                  ">" +
                  res.product.options.find(
                    (option) => option.name.toLowerCase() === "size"
                  )?.name +
                  " - " +
                  variant.option1 +
                  "</option>"
              )
            );
        } else {
          if (row.find("[data-size").attr("disabled") !== "disabled") {
            row.find("[data-size").attr("disabled", "");
          }
        }

        row.find("[data-size]").on("change", function (e) {
          if (e.target.value) {
            if (
              row.find("[data-addtocart]").attr("disabled") === "disabled"
            ) {
              row.find("[data-addtocart]").removeAttr("disabled");
            }
          } else {
            if (!row.find("[data-addtocart]").attr("disabled")) {
              row.find("[data-addtocart]").attr("disabled", "");
            }
          }
        });

        row.find("[data-addtocart]").on("click", function () {
          const value =
            row.find("[data-size]").val() ||
            row.find("[data-size] option:nth-child-2").attr("value");

          fetch(window.Shopify.routes.root + "cart/add.js", {
            body: JSON.stringify({
              id: parseInt(value),
              quantity: 1,
            }),
            headers: {
              "Content-Type": "application/json",
            },
            method: "post",
          }).then(() => {
            ajaxCart.load();
            row.find("[data-remove]").trigger("click");
          });
        });

        $("#wishlist-content").append(row);
      });
      });
    });
  };

  window.SwymCallbacks.push(function () {
    _swat.fetchWrtEventTypeET(function (products) {
      wishlistRender(products);
    }, _swat.EventTypes.addToWishlist);
  });
})(window, jQuery);
